export default "__VITE_PUBLIC_ASSET__f9a577ba__"